module.exports = __webpack_public_path__ + "img/download_7.a830869b.png";